<template>
  <div>
    <!-- 导航栏(PC) 开始 -->
    <div class="h50px gb-white shadow iristar-head w-total pc-hidden">
      <!-- 导航栏内容 -->
      <div class="main-box h50px mh-a flex a-i-c j-s-b">
        <!-- logo -->
        <div class="flex" style="height: 100%;gap:20px">
          <router-link to="/" style="display: inline-block;height:100%">
            <img src="../assets/img/logo2.png" height="100%" alt="中科虹星科技" />
          </router-link>

          <ul class="flex c-g-d fs12">
            <li :class="{ 'active-nav': $route.name === item.value }" class="nav-item ph18 h50px c-pointer p-r"
              v-for="(item, index) in headJson" :key="`${index}_nav`" @click=" go(item.value)">
              <div class="lh50 fs16">
                {{ $t(`HOME_NAV.${item.name}`) }}
                <i v-if="item.data" class="el-icon-caret-bottom"></i>
              </div>
              <div class="p-a nav-item-children gb-white shadow flex text-center"
                :class="`nav-posit${item.data.length}`" v-if="item.data">
                <ul class="w200px pv10" v-for="(itemChildren, itemIndex) in item.data" :key="`${itemIndex}_children`">
                  <div v-for="(column, columnIndex) in itemChildren" :key="columnIndex">
                    <h4 @click.stop="jumpPage(column.name)" v-if="column.showLabel" class="p6 c-g-d fs14">
                      {{ $t(`${column.name}.title`) }}
                    </h4>
                    <li class="fs14" v-for="(list, listIndex) in column.data" :key="`${listIndex}_list`"
                      @click.stop="jump(list, column, list)">
                      {{ $t(`${column.name}.${list.val}`) }}
                    </li>
                  </div>
                </ul>
              </div>
            </li>
          </ul>
        </div>

        <div class="flex gap10">
          <div class="flex" style="align-items: center;">
            <el-button type="primary">{{ $t(`apply`) }} </el-button>
          </div>

          <p style="font-size: 16px;display: flex;    gap: 5px;    align-items: center;"><i class="el-icon-phone"></i>
            <a href="tel:400-696-1828" class="c-block ahref">400-696-1828</a>
          </p>
          <!-- 中英文切换 -->
          <li class="lh50 ft14">
            <span class="c-pointer" :class="{ 'c-blue': language == 'zh' }" @click="changeLanguage('zh')">中</span>
            &nbsp;|&nbsp;
            <span class="c-pointer" :class="{ 'c-blue': language == 'en' }" @click="changeLanguage('en')">En</span>
          </li>
        </div>
      </div>
    </div>
    <!-- 导航栏(PC) 结束 -->

    <!-- 导航栏(移动端) 开始 -->
    <div class="
        iristar-head
        mobile-head
        h50px
        w-total
        mobil-hidden
        text-right
        c-white
        pr18
        lh50
        fs36
      ">
      <i @click="drawer = true" class="el-icon-s-fold"></i>
    </div>
    <el-drawer :show-close="false" boolean size="50%" :visible.sync="drawer" direction="rtl">
      <!-- logo -->
      <router-link class="text-center" href="/" style="display: block;">
        <img src="../assets/img/logo2.png" width="50%" alt="中科虹星科技" />
      </router-link>
      <!-- 导航 -->
      <el-menu class="ovh" router :default-active="mobilAc">
        <el-menu-item index="/index">
          <span slot="title">{{ $t(`HOME_NAV.home`) }}</span>
        </el-menu-item>
        <el-menu-item index="/iristar-core">
          <span slot="title">{{ $t(`HOME_NAV.core`) }}</span>
        </el-menu-item>
        <el-submenu index="/iristar-product">
          <template slot="title">
            <span>{{ $t(`HOME_NAV.product`) }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/iristar-software">{{ $t(`softwareTitle.title`) }}</el-menu-item>
            <el-menu-item index="/iristar-product">{{ $t(`hardware.title`) }}</el-menu-item>
            <!-- <el-menu-item index="/iristar-Module">{{ $t(`programme.title`) }}</el-menu-item> -->
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="/iristar-solution">

          <template slot="title">
            <span slot="title">{{ $t(`HOME_NAV.programme`) }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/solution-details/4">{{ $t(`programme.4`) }}</el-menu-item>
            <el-menu-item index="/solution-details/5">{{ $t(`programme.5`) }}</el-menu-item>
            <el-menu-item index="/solution-details/6">{{ $t(`programme.6`) }}</el-menu-item>
            <el-menu-item index="/solution-details/7">{{ $t(`programme.7`) }}</el-menu-item>
            <el-menu-item index="/solution-details/8">{{ $t(`programme.8`) }}</el-menu-item>
            <el-menu-item index="/solution-details/9">{{ $t(`programme.9`) }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <!-- 先屏蔽 -->
        <!-- <el-menu-item index="/iristar-news">
          <span slot="title">{{$t(`HOME_NAV.news`)}}</span>
        </el-menu-item> -->
        <el-menu-item index="/iristar-about">
          <span slot="title">{{ $t(`HOME_NAV.about`) }}</span>
        </el-menu-item>
        <el-menu-item index="/iristar-joinUs">
          <span slot="title">{{ $t(`HOME_NAV.Join`) }}</span>
        </el-menu-item>
        <el-menu-item>

          <!-- 中英文切换 -->
          <li class="lh50">
            <span class="c-pointer" :class="{ 'c-blue': language == 'zh' }" @click="changeLanguage('zh')">中</span>
            &nbsp;|&nbsp;
            <span class="c-pointer" :class="{ 'c-blue': language == 'en' }" @click="changeLanguage('en')">En</span>
          </li>
        </el-menu-item>
      </el-menu>
    </el-drawer>
    <!-- 导航栏(移动端) 开始 -->
  </div>
</template>

<script>
export default {
  name: "IristarHeader",
  data() {
    return {
      mobilAc: "index",
      drawer: false,
      language: "zh",
    };
  },
  methods: {
    go(value) {
      console.log(value)
      if ('iristarProduct' == value || 'iristarProgramme' == value) {
        return
      }
      this.$router.push({ name: value })
    },
    changeLanguage(lge) {
      this.$i18n.locale = this.language = lge;
      this.$store.commit("setLanguage", lge);
    },
    jumpPage(name) {
      switch (name) {
        case "aiService":
          // !模组
          this.$router.push({ path: "/iristar-aisoftware" })
          // this.$route.name !== "iristarModule" &&
          //   this.$router.push({ name: "iristarModule" });
          break;
        case "softwareTitle":
          // *软件
          this.$route.name !== "iristarSoftware" &&
            this.$router.push({ name: "iristarSoftware" });
          break;
        case "hardware":
          // &硬件
          this.$route.name !== "iristarProduct" &&
            this.$router.push({ name: "iristarProduct" });
      }
    },
    jump(list, obj, item) {
      let objIndex = "";
      let path = "";
      switch (obj.name) {
        case "aiService":
          // !模组
          this.$router.push({ path: "/iristar-aisoftware" })
          // this.$route.name !== "iristarModule" &&
          //   this.$router.push({ name: "iristarModule" });
          break;
        case "module":
          // !模组
          this.$router.push({
            path: `/module-details/${list.type}`,
          });
          break;
        case "softwareTitle":

          this.$router.push({ path: "/iristar-software", query: { anchor: item.val } });
          break;
        case "service":
          // *软件
          // this.$router.push({
          this.$router.push({ path: "/iristar-aisoftware" })
          // path: `/service-details/${list.type}`,
          // });
          break;
        case 'cv':
        case 'hardware':
        case "recognition":
          // &硬件
          this.$router.push({
            path: `/product-details/${list.type}`,
          });
          break;
        case "programme":
          // ^解决方案
          objIndex = list.val
          // if (objIndex == "6") {
          //   path = `/iristar-solution-factory`;
          // } else if (objIndex == "8") {
          //   path = `/iristar-solution-swzy`;
          // } else {

          // }
          path = `/solution-details/${objIndex}`
          this.$router.push({ path: path });
          break
      }
    },
  },
  props: {
    headJson: {
      type: Array,
      default: () => {
        return [
          {
            name: "home",
            label: "首页",
            value: "iristarHome",
          },
          {
            name: "core",
            label: "核心技术",
            value: "iristarCore",
          },
          {
            name: "product",
            label: "产品中心",
            value: "iristarProduct",
            data: [
              [{
                name: "softwareTitle",
                showLabel: true,
                data: [
                  { type: "a0", val: "a0" },
                  { type: "a1", val: "a1" },
                  { type: "a2", val: "a2" },
                  { type: "a3", val: "a3" },
                  { type: "a4", val: "a4" },
                  { type: "a5", val: "a5" },
                ],
              }],
              [{
                name: "hardware",
                showLabel: true,

                data: [
                  // {
                  //   type: "S320-T1",
                  //   val: "hardware1",
                  // },
                  {
                    type: "S200P",
                    val: "hardware4",
                  },
                  {
                    type: "S260P",
                    val: "hardware5",
                  },
                  {
                    type: "S330B",
                    val: "hardware10",
                  },
                  {
                    type: "S310",
                    val: "hardware12",
                  },
                  {
                    type: "W200",
                    val: "hardware2",
                  },

                  {
                    type: "S300-UC",
                    val: "hardware3",
                  },

                  {
                    type: "AI视觉分析边缘计算盒子",
                    val: "aibox"
                  },
                  {
                    type: "AI视觉分析服务器",
                    val: "aianalyse"
                  },





                  // {
                  //   type: "S210G-S320G",
                  //   val: "hardware6",
                  // },
                  // {
                  //   type: "S320",
                  //   val: "hardware7",
                  // },
                  // {
                  //   type: "F200",
                  //   val: "hardware8",
                  // },
                  // {
                  //   type: "IriSign",
                  //   val: "hardware9",
                  // },


                  // {
                  //   type: "S330-T",
                  //   val: "hardware11",
                  // },

                  // {
                  //   type: "F300",
                  //   val: "hardware13",
                  // },
                  // {
                  //   type: "工地人脸识别一体机",
                  //   val: "hardware14",
                  // },
                  // {
                  //   type: "F100",
                  //   val: "hardware15",
                  // },
                  // {
                  //   type: "F100(linux)",
                  //   val: "hardware16",
                  // },
                ],
              },
                // {
                //   name: "software",
                //   showLabel: true,
                //   data: [
                //     { type: "datacenter", val: "datacenter" },
                //     { type: "discern", val: "discern" },
                //     { type: "collection", val: "collection" },
                //   ]
                // }, 
                // {
                //   name: "cv",
                //   showLabel: true,
                //   data: [
                //     { type: "AI视觉分析边缘计算盒子", val: "aibox" },
                //     { type: "AI视觉分析服务器", val: "aianalyse" },
                //   ]
                // }
              ],
              // [{
              //   name: "aiService",
              //   showLabel: true,
              //   data: [
              //     {
              //       type: "a1",
              //       val: "a1",
              //     },

              //   ]
              // }],
              // [{
              //   name: "module",
              //   showLabel: true,
              //   data: [
              //     {
              //       type: "内窥镜模组",
              //       val: "module3",
              //     },
              //     {
              //       type: "USB3",
              //       val: "module4",
              //     },
              //     {
              //       type: "M300B",
              //       val: "module2",
              //     },
              //     {
              //       type: "S300KQ",
              //       val: "module1",
              //     },
              //   ],
              // }],
            ],
          },
          {
            name: "programme",
            label: "行业服务",
            value: "iristarProgramme",
            data: [
              [{
                name: "programme",
                showLabel: false,
                data: [
                  // {
                  //   type: "programme",
                  //   val: "programme1",
                  // },
                  // {
                  //   type: "programme",
                  //   val: "programme2",
                  // },
                  // {
                  //   type: "programme",
                  //   val: "programme3",
                  // },
                  {
                    type: "programme",
                    val: "4",
                  },
                  {
                    type: "programme",
                    val: "5",
                  },
                  {
                    type: "programme",
                    val: "6",
                  },
                  {
                    type: "programme",
                    val: "7",
                  },
                  {
                    type: "programme",
                    val: "8",
                  },
                  {
                    type: "programme",
                    val: "9",
                  },
                ],
              }],
            ],
          },
          {
            name: "news",
            label: "新闻中心",
            value: "iristarNews",
          },
          {
            name: "about",
            label: "关于我们",
            value: "iristarAbout",
          },
          {
            name: "Join",
            label: "加入我们",
            value: "iristarJoinUs",
          },
        ];
      },
    },
  },
};
</script>

<style scoped lang="less">
.nav-item:hover .nav-item-children {
  position: absolute;
  max-height: 800px;
  overflow: auto;
}
</style>
